import { all, takeLatest, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import {
  requestViewAllNotifications,
  requestQueryNewNotifications,
  requestViewNewNotifications
} from './notification.actions';
import {
  getViewAllNotificationsRequest,
  getQueryNewNotificationsRequest,
  getViewNewNotificationsRequest
} from './notification.endpoints';

import { setNotifications, prependNotifications, setNewNotifications } from '../../slices/system/system.slice';
import { addSystemNotice } from '../../slices/system/system.slice';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';

export function* performViewAllNotificationsRequest({ payload }) {
  const { systemUserExternalReference, onSuccess } = payload;

  try {
    const [endpoint, options] = getViewAllNotificationsRequest(systemUserExternalReference);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(setNotifications(data.notifications));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewAllNotificationsRequest() {
  yield takeLatest(requestViewAllNotifications.type, performViewAllNotificationsRequest);
}

export function* performQueryNewNotificationsRequest({ payload }) {
  const { systemUserExternalReference, lastNotificationUUID, onSuccess } = payload;

  try {
    const [endpoint, options] = getQueryNewNotificationsRequest(systemUserExternalReference, lastNotificationUUID);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess, data.areNewNotifications);
    }
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForQueryNewNotificationsRequest() {
  yield takeLatest(requestQueryNewNotifications.type, performQueryNewNotificationsRequest);
}

export function* performViewNewNotificationsRequest({ payload }) {
  const { systemUserExternalReference, lastNotificationUUID, onSuccess } = payload;

  try {
    const [endpoint, options] = getViewNewNotificationsRequest(systemUserExternalReference, lastNotificationUUID);

    const { data } = yield call(axios, endpoint, options);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(setNewNotifications(true));
    yield put(prependNotifications(data.newNotifications));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForViewNewNotificationsRequest() {
  yield takeLatest(requestViewNewNotifications.type, performViewNewNotificationsRequest);
}

export default function* notificationSaga() {
  yield all([
    watchForViewAllNotificationsRequest(),
    watchForQueryNewNotificationsRequest(),
    watchForViewNewNotificationsRequest()
  ]);
}
